import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.clickEl = this.$('click-el')[0];
    }
    init() {
        this.clickEl.addEventListener( 'click', () => {
            [...document.querySelectorAll('[data-share-class-toggle-el]')].forEach(target => {
                [ ...target.dataset.shareClassToggle.split( ' ' ) ].map( className => {
                    target.classList.toggle( className );
                } );
            });
        } );
    }
    destroy(){}
}
